import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram, Youtube, Twitter, Linkedin, ArrowRight, Play, Smartphone, Globe } from 'lucide-react';
import Logo from '../../assets/images/logo/logo.png';
import VersatileLogo from '../../assets/images/logo/versatile.png';

export const Footer = () => {
  const quickLinks = [
    { name: 'About Us', path: '/about' },
    { name: 'Courses', path: '/courses' },
    { name: 'Results', path: '/results' },
    { name: 'Faculty', path: '/faculty' },
    { name: 'Contact', path: '/contact' }
  ];

  const programs = [
    { name: 'Foundation Course', path: '/courses#foundation' },
    { name: 'JEE Main & Advanced', path: '/courses#jee' },
    { name: 'NEET Preparation', path: '/courses#neet' },
    { name: 'Dropper Batches', path: '/courses#dropper' }
  ];

  const socialLinks = [
    { icon: Facebook, url: 'https://www.facebook.com/share/16gzVPrbPj/?mibextid=wwXIfr', label: 'Facebook' },
    { icon: Instagram, url: 'https://www.instagram.com/prayas_institute_iitjee_neet/', label: 'Instagram' },
    { icon: Youtube, url: 'https://www.youtube.com/channel/UCO4AGHWrJF9byVPncMVqqAw', label: 'YouTube' },
    { icon: Twitter, url: 'https://twitter.com/mantra_prayas', label: 'Twitter' },
    { icon: Linkedin, url: 'https://www.linkedin.com/in/prayas-institute-13831b232/', label: 'LinkedIn' },
    { icon: Play, url: 'https://play.google.com/store/apps/details?id=com.onlinetestpanel.prayas&pcampaignid=web_share', label: 'Android App' },
    { icon: Smartphone, url: 'https://apps.apple.com/in/app/mantra-prayas/id6742650800', label: 'iOS App' },
    { icon: Globe, url: 'http://Prayas.onlinetestpanel.com', label: 'Online Test Portal' }
  ];

  return (
    <footer className="bg-primary text-primary-foreground">
      {/* Main Footer Content */}
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* About Section */}
          <div className="space-y-6">
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                {/* Logo */}
                <Link to="/" className="flex items-center space-x-3 group">
                  <div className="sm:block w-52">
                    <img src={Logo} className="logo" alt="" />
                  </div>
                </Link>
              </div>
              <p className="text-sm text-primary-foreground/90 leading-relaxed">
                Empowering students to achieve their dreams through quality education and dedicated mentorship for IIT-JEE, NEET.
              </p>
            </div>

            {/* Social Links */}
            <div className="grid grid-cols-4 gap-3 w-fit">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="h-10 w-10 md:h-8 md:w-8 xl:h-10 xl:w-10 rounded-full bg-primary-foreground/10 hover:bg-secondary flex items-center justify-center transition-all hover:scale-110"
                >
                  <social.icon className="h-5 w-5 md:h-4 md:w-4 xl:h-5 xl:w-5" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-heading font-semibold mb-9 mt-5">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.path}
                    className="text-sm text-primary-foreground/90 hover:text-accent-gold hover:translate-x-1 inline-flex items-center transition-all group"
                  >
                    <ArrowRight className="h-4 w-4 mr-2 opacity-0 -ml-6 group-hover:opacity-100 group-hover:ml-0 transition-all" />
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h4 className="text-lg font-heading font-semibold mb-9 mt-5">Our Courses</h4>
            <ul className="space-y-3">
              {programs.map((program, index) => (
                <li key={index}>
                  <Link
                    to={program.path}
                    className="text-sm text-primary-foreground/90 hover:text-accent-gold hover:translate-x-1 inline-flex items-center transition-all group"
                  >
                    <ArrowRight className="h-4 w-4 mr-2 opacity-0 -ml-6 group-hover:opacity-100 group-hover:ml-0 transition-all" />
                    {program.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources & Newsletter */}
          <div>
            <h4 className="text-lg font-heading font-semibold mb-9 mt-5">Contact us</h4>
            {/* Contact Info */}
            <div className="space-y-3">
              <div className="flex items-start space-x-3 ">
                <Phone className="h-5 w-5 mt-0.5 flex-shrink-0" />
                <ul className="block">
                  <li className="leading-3"><a href="tel:+918982845157" className="text-sm hover:text-accent-gold transition-colors group">+91 89828 45157</a></li>
                  <li className="leading-3"><a href="tel:+918839354369" className="text-sm hover:text-accent-gold transition-colors group">+91 88393 54369</a></li>
                  <li className="leading-3"><a href="tel:+919024426331" className="text-sm hover:text-accent-gold transition-colors group">+91 90244 26331</a></li>
                </ul>
              </div>
              <a href="mailto:mantrajeeneet@gmail.com" className="flex items-start space-x-3 text-sm hover:text-accent-gold transition-colors group">
                <Mail className="h-5 w-5 mt-0.5 flex-shrink-0" />
                <span>mantrajeeneet@gmail.com</span>
              </a>
              <div className="flex items-start space-x-3 text-sm">
                <MapPin className="h-5 w-5 mt-0.5 flex-shrink-0" />
                <span>08, Hemukalani Circle, Sindhu Nagar, Bhilwara, Rajasthan - 311001</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-primary-foreground/10">
        <div className="container-custom py-6">
          <div className="text-center space-y-4 md:space-y-0">
            <p className="text-sm text-primary-foreground/80 flex flex-col md:flex-row justify-center">
              © {new Date().getFullYear()} Mantra Prayas. All rights reserved | Design & Developed by
              <Link href="http://www.versatileitsolution.com" className="text-[#E5C07B] hover:text-white flex items-center gap-1">
                <img alt="Versatile IT Solution" className="h-5 m-auto lg:ml-2" src={VersatileLogo} />
              </Link>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
